module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"FinPortfolioOverviewPart":{"yield_since_start":"Rendite seit Start"}},"en":{"FinPortfolioOverviewPart":{"yield_since_start":"Yield since start"}}}')
  delete Component.options._Ctor
}
